import { MouseWheelZoom } from 'ol/interaction';

export class PmaMouseWheelZoom extends MouseWheelZoom {
    constructor(options) {
        super(options);
        if (!this.hasOwnProperty("deltaPerZoom_")) {
            throw "deltaPerZoom_ not found";
        }

        this.deltaPerZoom_ = options.deltaPerZoom;
    }
}
